<template>
  <app-badge
    size="sm"
    :color="badgeColor"
  >
    {{ status }}
  </app-badge>
</template>

<script setup>
import { computed } from 'vue';
import { UserMultifactorStatus } from '@/constants/users';

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: (value) => Object.values(UserMultifactorStatus).includes(value),
  },
});

const badgeColor = computed(() => {
  return {
    [UserMultifactorStatus.ENABLED]: 'success',
    [UserMultifactorStatus.DISABLED]: 'neutral',
  }[props.status];
});
</script>
